/**
 *
 * AssignedTag
 *
 */

import React, { memo } from 'react';
import styled from 'styled-components';

import PinTripIcon from 'assets/v2/PinTripIcon';
import { COLORS } from 'theme';
import Tag from '..';

const StyledTag = styled(Tag)`
  &.MuiChip-root {
    color: ${COLORS.goldMetalicDark};
    background: ${COLORS.goldMetalicLight};
    border-color: ${COLORS.goldMetalic};
    border-radius: ${({ theme }) => theme.borderRadius.secondary};

    &&& .MuiChip-icon path {
      fill: ${COLORS.goldMetalic};
    }
  }
`;

function AssignedTag(props) {
  return <StyledTag label="Assigned" icon={<PinTripIcon />} {...props} />;
}

export default memo(AssignedTag);
